module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Forms","action":{"create":"New"},"emptyTable":"There are no Forms to show.","alert":{"create":"Your new Form “{name}” has been created as a Draft. Take a look at the checklist below, and when you feel it’s ready, you can publish the Form for use."}}}')
  delete Component.options._Ctor
}
